import React, { useEffect } from 'react';
import '../App.css'

const TopicList = ({ topics, setActiveComponent, setSelectedTopic }) => {
  // if (!selectedProjectData) return <div>Loading...</div>;

  useEffect(() => {

  })

  const handleClick = (topic) => {
    setActiveComponent("TopicChat")
    setSelectedTopic(topic)
  }

  return (
    // <div className="wrapper">
    <>
      <p>Topics in this case</p>
      <div>
        <ul>
          {topics.map((topic, index) => (
            <li style={{ cursor: 'pointer' }}
            key={index} onClick={() => handleClick(topic)}><a>{topic.title}</a></li>))}
        </ul>
      </div>

      {/* <h2>Case Name: {selectedProjectData.case_name}</h2>
          {selectedProjectData.tasks.map((task) => (
            <div key={task.task_id} style={{ marginBottom: '40px' }}>
              <h3>Project Name: {task.project_name}</h3>
              <table border="1" cellPadding="8" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                  <tr>
                    <th>任務名稱</th>
                    <th>負責人</th>
                    <th>到期日</th>
                    <th>狀態</th>
                    <th>備註</th>
                  </tr>
                </thead>
                <tbody>
                  {task.variants.map(variant =>
                    variant.details.map(detail => (
                      <tr key={detail.detail_id}>
                        <td>{variant.task_name}</td>
                        <td>{detail.people}</td>
                        <td>{detail.due_date}</td>
                        <td>{detail.status}</td>
                        <td>{detail.note}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ))} */}
    </>
    // </div>
  );
};

export default TopicList;